<template>
  <div class="distribute">
    <div class="line_H">
      <div>小时均值分布</div>
    </div>

    <div class="search">
      <div class="subT">
        <button v-for="item in typeList" v-bind:key="item.name" :class="{'active':sensorType == item.name}" @click="search(item.name)" v-html="item.ename"></button>
      </div>
      <span>开始时间</span>
      <input type="text" id="beginTime" placeholder="开始时间" class="datetimeInput">
      <span style="margin-left: 20px;">结束时间</span>
      <input type="text" id="endTime" placeholder="结束时间" class="datetimeInput">
      <span class="search_btn" @click="search()"  v-if="userConfig.platform == 'shenyang'">查询</span>
      <div style="margin-top: 20px;" v-if="userConfig.platform == 'base'">
        <span>省：</span>
        <Select v-model="province" style="width: 150px;" @on-change="provinceChange">
            <Option v-for="item in provinceList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span>市：</span>
        <Select v-model="city" style="width: 150px;" @on-change="cityChange">
            <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <span>区：</span>
        <Select v-model="district" style="width: 150px;">
            <Option v-for="item in districtList" :value="item.id" :key="item.id">{{ item.name }}</Option>
        </Select>
        <!--<span>类型：</span>-->
        <!--<Select v-model="monitorAreaType" style="width: 150px;">-->
            <!--<Option v-for="item in monitorAreaTypeList" :value="item.id" :key="item.id">{{ item.name }}</Option>-->
        <!--</Select>-->
        <span class="search_btn" @click="search()">查询</span>
      </div>
    </div>
    <div class="charts">
      <div class="colorTag1" v-if="sensorType != 'voc'">
        <img :src="'static/imgs/L'+sensorType+'.png'" />
      </div>
      <div class="conBox">
        <el-scrollbar style="height: 100%">
          <div id="container" class="container"></div>
        </el-scrollbar>
      </div>
    </div>
  </div>
</template>

<script>
  import Dateformat from "../../utils/dateformat.js";
  const echarts = require("echarts");
  export default {
    name: "distribute",
    data() {
      return {
        userConfig: {},
        state: 0,
        typeList:[],
        clientTop: "3%",
        myChart: null,
        sensorType:'',
        unit:'',
        averSeries: {
          greenNum: [],
          yellowNum: [],
          orangeNum: [],
          redNum: [],
          purpleNum: [],
          maroonNum: [],
          csites: []
        },
        monitorAreaTypeList: [],
        monitorAreaType: 1,
        provinceList: [],
        province: "",
        cityList: [],
        city: "",
        districtList: [],
        district: ""
      };
    },
    methods: {
      getMonitorStationTypes(){
        this.$http
          .get(this.userConfig.apiName + "/v4/monitorStationTypes")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              // this.$set(this,'monitorAreaTypeList',result);
              // this.$set(this,'monitorAreaType',result[0].id);
              this.getType();
            }

          });
      },
      getProvince(){
        this.$http
          .get(this.userConfig.apiName + "/v4/provinces")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'provinceList',result);
              this.$set(this,'province',result[0].id);
              this.getCity();
            }
          });
      },
      provinceChange() {
        this.getCity();
      },
      getCity(){
        this.$http
          .get(this.userConfig.apiName + "/v4/provinces/" + this.province + "/cities")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'cityList',result);
              this.$set(this,'city',result[0].id);
              this.getDistrict()
            }
          });
      },
      cityChange() {
        this.getDistrict();
      },
      getDistrict(){
        this.$http
          .get(this.userConfig.apiName + "/v4/cities/" + this.city + "/districts")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              this.$set(this,'districtList',result);
              this.$set(this,'district',result[0].id);
            }
          });
      },
      getType(){
        this.$http
          .get(this.userConfig.apiName + "/v4/importantSensors")
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data;
              if(result){
                this.$set(this,'sensorType',result[0].name);
                this.$set(this,'unit',result[0].unit);
                this.$set(this,'typeList',result);
              }
              setTimeout(this.getData(),2000);
            }
          });
      },
      // 初始化图表
      initChart() {
        this.myChart = echarts.init(document.getElementById("container"));
      },

      getTime() {
        let beginDate = new Date(new Date().getTime());
        let beginTime = beginDate.getFullYear() + "-" + ((beginDate.getMonth() + 1) < 9 ? "0" + (beginDate.getMonth() + 1): (beginDate.getMonth() + 1)) + "-" + (beginDate.getDate() < 9 ? "0" + beginDate.getDate():beginDate.getDate()) + " 00:00:00";
        document.getElementById("beginTime").value = beginTime;

        let endDate = new Date();
        let endTime = endDate.getFullYear() + "-" + ((endDate.getMonth() + 1) < 9 ? "0" + (endDate.getMonth() + 1): (endDate.getMonth() + 1)) + "-" + (endDate.getDate() < 9 ? "0" + endDate.getDate():endDate.getDate()) + " " + (endDate.getHours() < 9 ? "0" + endDate.getHours():endDate.getHours()) + ":" + (endDate.getMinutes() < 9 ? "0" + endDate.getMinutes():beginDate.getMinutes()) + ":" + (endDate.getSeconds() < 9 ? "0" + endDate.getSeconds():endDate.getSeconds());
        document.getElementById("endTime").value = endTime;
      },

      getData() {
        for (let key in this.averSeries) {
          this.averSeries[key] = [];
        }
        let params = {
          sensorType: this.sensorType,
          beginTime: document.getElementById("beginTime").value,
          endTime: document.getElementById("endTime").value,
          monitorStationType: this.monitorAreaType,
          districtId: this.district
        };
        if(this.userConfig.platform == "shenyang"){
          params = {
            sensorType: this.sensorType,
            beginTime: document.getElementById("beginTime").value,
            endTime: document.getElementById("endTime").value
          };
        }
        this.$http
          .get(this.userConfig.apiName + "/v4/sampleMonitorAnalyze/distribution", {
            params: params
          })
          .then(response => {
            if(response.data.code == 0){
              let result = response.data.data.content;
              this.setHeight(result.length);
              for(let i = 0; i < result.length; i++){
                if (
                  result[i].greenNum ||
                  result[i].yellowNum ||
                  result[i].orangeNum ||
                  result[i].redNum ||
                  result[i].purpleNum ||
                  result[i].maroonNum
                ) {
                  this.averSeries.greenNum.push(result[i].greenNum);
                  this.averSeries.yellowNum.push(result[i].yellowNum);
                  this.averSeries.orangeNum.push(result[i].orangeNum);
                  this.averSeries.redNum.push(result[i].redNum);
                  this.averSeries.purpleNum.push(result[i].purpleNum);
                  this.averSeries.maroonNum.push(result[i].maroonNum);
                  this.averSeries.csites.push(result[i].csiteName);
                }
              }
              this.setOption();
            }
          });
      },

      setHeight(len){
       let heigh = len*40;
       let el = document.getElementById('container');
       el.style.height = heigh + 'px';
      },

      // 图表配置选项
      setOption() {
        this.myChart.setOption(this.getOption(), true);
        this.myChart.resize();
      },

      getOption() {
        let option = {
          grid: {
            top: "20",
            left: "20",
            right: "20",
            bottom:'7%',
            containLabel: true
          },
          xAxis: {
            type: "value",
            // max: 100,
            position: "bottom",
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#0bfcd7",
                width: "1"
              }
            },
            splitLine: {
              show: false
            },
            axisLabel: {
              show: true,
              textStyle: {
                color: "#0bfcd7"
              }
            }
          },
          yAxis: {
            type: "category",
            // max:120,
            splitLine: {
              show: false
            },
            axisLine: {
              lineStyle: {
                type: "solid",
                color: "#0bfcd7",
                width: "1"
              }
            },
            axisLabel: {
              textStyle: {
                color: "#0bfcd7"
              }
            },
            data: this.averSeries.csites
          },
          tooltip: {
            show: false,
            formatter: "{b0}<br />"+this.sensorType+'('+this.unit+"): {c0}"
          },
          series: [
            {
              name: "0-50",
              type: "bar",
              barWidth: 15,
              stack: '总量',
              itemStyle: {
                normal: {
                  color: "#43cf18"
                }
              },
              data: this.averSeries.greenNum
            },
            {
              name: "51-100",
              type: "bar",
              barWidth: 15,
              stack: "总量",
              itemStyle: {
                normal: {
                  color: "#f0db32"
                }
              },
              data: this.averSeries.yellowNum
            },
            {
              name: "101-150",
              type: "bar",
              barWidth: 15,
              stack: '总量',
              itemStyle: {
                normal: {
                  color: "#ffaa02"
                }
              },
              data: this.averSeries.orangeNum
            },
            {
              name: "151-200",
              type: "bar",
              barWidth: 15,
              stack: '总量',
              itemStyle: {
                normal: {
                  color: "#f2403c"
                }
              },
              data: this.averSeries.redNum
            },
            {
              name: "201-300",
              type: "bar",
              barWidth: 15,
              stack: '总量',
              itemStyle: {
                normal: {
                  color: "#9a034a"
                }
              },
              data: this.averSeries.purpleNum
            },
            {
              name: ">300",
              type: "bar",
              barWidth: 15,
              barCateGoryGap:100,
              stack: '总量',
              itemStyle: {
                normal: {
                  color: "#7f0220"
                }
              },
              data: this.averSeries.maroonNum
            }
          ]
        };
        return option;
      },

      search(str) {
        if(str){
          this.sensorType = str;
          let typeList = this.typeList;
          for(let i = 0; i <typeList.length;i++ ){
            if(str == typeList[i].name){
              this.unit = typeList[i].unit;
            }
          }
        }
        this.getData();
      }
    },
    mounted() {
      this.$set(this,"userConfig",JSON.parse(window.sessionStorage.getItem("userConfig")));
      if(this.userConfig){
        this.getTime();
        this.getProvince();
        this.initChart();
        this.getMonitorStationTypes();
        $(".datetimeInput").datetimepicker({
          format: "yyyy-mm-dd hh:ii:ss",
          autoclose: true,
          todayBtn: true,
          language:'zh-CN'
        });
      }
    }
  };
</script>

<style scoped lang="less">
  .distribute {
    position: absolute;
    top: 1.2rem;
    left: 0px;
    right: 0px;
    box-sizing: border-box;
    width: 80%;
    margin: auto;
    padding: 20px;
    .prevPage{
      position: absolute;
      top: -60px;
      left: 0px;
      cursor: pointer;
    }
    .nextPage{
      position: absolute;
      top: -60px;
      right: 0px;
      cursor: pointer;
    }
    .line_H{
      color: #0bfcd7;
      font-size: 0.22rem;
      background: #091d3d;
    }
    .search {
      margin-top: 20px;
      color: #fff;
      font-size: 14px;
      span.active {
        background-color: #035e85;
      }
      .search_btn{
        background: #0e2e42;
        color: #fff;
        outline: none;
        margin-left: 20px;
        &:hover{
          background: #0d4568;
        }
      }
      .subT {
        display: inline-block;
        padding-top: 5px;
        margin-right: 0.2rem;

        button {
          border: none;
          border-radius: 4px;
          padding: 4px 0.18rem;
          background: #0e2e42;
          color: #0bfcd7;
          outline: none;
          &:hover{
            background: #0d4568;
          }
        }
        .active {
          background: #0d4568;
        }
      }
    }
    .charts {
      width: 90%;
      margin: 0 auto;
      position: relative;
      .colorTag1 {
        text-align: center;
        margin-top: 10px;
        p {
          display: inline-block;
          margin: 0 5px;
          span {
            display: inline-block;
            width: 20px;
            height: 10px;
            border-radius: 2px;
            vertical-align: middle;
          }
          strong {
            font-size: 13px;
            margin-left: 3px;
            vertical-align: middle;
          }
        }
      }
      .colorTag1 p:nth-of-type(1) {
        span {
          background-color: #43cf18;
        }
        strong {
          color: #43cf18;
          vertical-align: middle;
        }
      }
      .colorTag1 p:nth-of-type(2) {
        span {
          background-color: #f0db32;
        }
        strong {
          color: #f0db32;
        }
      }
      .colorTag1 p:nth-of-type(3) {
        span {
          background-color: #ffaa02;
        }
        strong {
          color: #ffaa02;
        }
      }
      .colorTag1 p:nth-of-type(4) {
        span {
          background-color: #f2403c;
        }
        strong {
          color: #f2403c;
        }
      }
      .colorTag1 p:nth-of-type(5) {
        span {
          background-color: #9a034a;
        }
        strong {
          color: #9a034a;
        }
      }
      .colorTag1 p:nth-of-type(6) {
        span {
          background-color: #7f0220;
        }
        strong {
          color: #7f0220;
        }
      }

      .conBox {
        width: 100%;
        // height: 500px;
        overflow-y: auto;
      }
      .container {
        width: 100%;
        // height: 500px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/analysis/hourAvg.vue